import script from "./CustomAutoComplete.vue?vue&type=script&lang=ts&setup=true"
export * from "./CustomAutoComplete.vue?vue&type=script&lang=ts&setup=true"

import "./CustomAutoComplete.vue?vue&type=style&index=0&id=426d3f88&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-426d3f88"]])

export default __exports__